module.exports = __webpack_public_path__ + "img/key-dude.40741712.svg";